import { ListBullets } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase } from "../LibraryPrimitives";
import { List, LessonListItem, HomeworkListItem, AchievementListItem, TopicListItem } from "../lists";

export function ListsSection() {
  return (
    <SectionShell
      id="lists"
      eyebrow="Lists"
      eyebrowIcon={ListBullets}
      title="Clear, scannable, tappable rows"
      description="Lists organise lessons, homework and achievements into calm, easy-to-scan rows with big tap targets and a clear sense of where you are."
    >
      <div className="grid gap-5 lg:grid-cols-2">
        <Showcase title="Lesson list">
          <List>
            <LessonListItem index={1} title="Counting to 100" state="done" />
            <LessonListItem index={2} title="Tens and ones" state="done" />
            <LessonListItem index={3} title="Adding to 20" state="current" />
            <LessonListItem index={4} title="Subtraction" state="locked" />
          </List>
        </Showcase>

        <Showcase title="Homework list">
          <List>
            <HomeworkListItem title="Spelling list 4" subject="english" due="Fri" />
            <HomeworkListItem title="Times tables: 6×" subject="maths" due="Mon" />
            <HomeworkListItem title="Read 'The Little Seed'" subject="reading" due="Wed" done />
          </List>
        </Showcase>

        <Showcase title="Achievement list">
          <List>
            <AchievementListItem title="Read 5 stories" xp={30} unlocked />
            <AchievementListItem title="Perfect week" xp={50} unlocked />
            <AchievementListItem title="Maths master" xp={100} unlocked={false} />
          </List>
        </Showcase>

        <Showcase title="Topic list">
          <List>
            <TopicListItem title="Fractions" subject="maths" count={8} />
            <TopicListItem title="Phonics" subject="english" count={12} />
            <TopicListItem title="Living things" subject="science" count={6} />
            <TopicListItem title="Comprehension" subject="reading" count={9} />
          </List>
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default ListsSection;
